import React, { useEffect, useState } from "react";
import CustomerSupportAside from "./CustomerSupportAside";
import axios from "axios";

function CustomerSupportManagerFollowup() {
    const [institutes, setInstitutes] = useState([]);
    const [selectedInstitute, setSelectedInstitute] = useState("");
    const [followUpData, setFollowUpData] = useState({
        empId: "",
        empName: "",
        designation: "",
        instituteName: "",
        instituteAddress: "",
        contactPerson: "",
        contactDesignation: "",
        contactNumber: "",
        lastVisited: "",
        interest: "",
        next_followup_date: "",
        comment: "",
        interestShown: "",
    });

    const [schoolName, setSchoolName] = useState("");
    const [schools, setSchools] = useState([]);
    const [followupDate, setFollowupDate] = useState(
        new Date().toISOString().split("T")[0],
    ); // automatically select today as the default
    const [issueFaced, setIssueFaced] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [addBtnPopup, setAddBtnPopup] = useState(false)

    const [followupList, setFollowupList] = useState([]);
    const [schoolHistory, setSchoolHistory] = useState([]); // to store the school history data in the followup component
    const [selectedHistorySchool, setSelectedHistorySchool] = useState("");
    const [searchSchool, setSearchSchool] = useState("");

   const fetchFollowups = async () => {
  try {
    const response = await axios.get(
      "https://cleezoclass.com:8443/api/customer-support/followup",
    );

    // API returns { success, count, data: [...] } — grab the array
    const rows = Array.isArray(response.data?.data) ? response.data.data : [];

    // Map API field names (snake_case) to what the JSX expects (camelCase)
    const mapped = rows.map((item) => ({
      id: item.id,
      schoolName: item.school_name,
      followupDate: item.followup_date
        ? item.followup_date.split("T")[0]
        : "",
      issueFaced: item.issue_faced,
      comment: item.comment || "",
      interestShown: item.interest_shown || item.interestShown || "",
      followupPerson: item.followup_person,
    }));

    setFollowupList(mapped);
  } catch (error) {
    console.log(error);
  }
};


    useEffect(() => {
        fetchFollowups();
    }, []);

    const handleSchoolHistory = async (schoolName) => {
        setSelectedHistorySchool(schoolName);

        try {
            const response = await axios.get(
                `https://cleezoclass.com:8443/api/customer-support/history/${encodeURIComponent(
                    schoolName,
                )}`,
            );

            setSchoolHistory(response.data);
        } catch (error) {
            console.error(error);
        }
    };

    const Exicutive = localStorage.getItem("empName");

    // To get the centeralized schooldetails
    useEffect(() => {
        axios
            .get("https://cleezoclass.com:8443/api/schools")
            .then((response) => {
                setSchools(response.data);
            })
            .catch((error) => {
                console.error(error);
                setErrorMessage("Failed to load schools.");
            });
    }, []);

    console.log(schools.institute_name);
    console.log("Selected School:", selectedInstitute);

    const handleSubmit = async () => {
        try {
            setSuccessMessage("");
            setErrorMessage("");

            if (!schoolName) {
                setErrorMessage("Please select a school.");
                return;
            }

            if (!issueFaced.trim()) {
                setErrorMessage("Please enter issue faced.");
                return;
            }
            const payload = {
                schoolName,
                followupDate,
                issueFaced,
                comment: followUpData.comment,
                interestShown: followUpData.interestShown,
                followupPerson: Exicutive,
            };

            console.log("Sending:", payload);

            const response = await axios.post(
                "https://cleezoclass.com:8443/api/customer-support/followup",
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                },
            );

            if (response.data.success) {
                setSuccessMessage(response.data.message);

                // Clear form
                setSchoolName("");
                setIssueFaced("");

                // Reset date to today
                setFollowupDate(new Date().toISOString().split("T")[0]);

                fetchFollowups();
            }
        } catch (error) {
            console.error(error);

            setErrorMessage(
                error?.response?.data?.message || "Failed to save follow-up.",
            );
        }
    };

    const handleFollowUpChange = (e) => {
        const { name, value } = e.target;
        setFollowUpData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    useEffect(() => {
        const storedEmpId = localStorage.getItem("empId");
        const storedEmpName = localStorage.getItem("empName");
        const storedDesignation = localStorage.getItem("designation");

        if (storedEmpId && storedEmpName && storedDesignation) {
            setFollowUpData((prevData) => ({
                ...prevData,
                empId: storedEmpId,
                empName: storedEmpName,
                designation: storedDesignation,
            }));
        } else {
            alert(
                "Session expired or employee details not found. Please log in again.",
            );
            window.location.href = "https://crm-nova.tagsol.in";
        }
    }, []);


    useEffect(() => {
        if (selectedInstitute) {
            const token = localStorage.getItem("authToken");
            axios
                .get(
                    `https://cleezoclass.com:8443/api/sales-performance/${selectedInstitute}`,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    },
                )
                .then((response) => {
                    const data = response.data;
                    setFollowUpData((prevData) => ({
                        ...prevData,
                        instituteName: data.institutename,
                        instituteAddress: data.instituteaddress,
                        contactPerson: data.contactperson,
                        contactDesignation: data.contactpersondesignation,
                        contactNumber: data.contactpersonnumber,
                        lastVisited: formatDateToYMD(data.followupdate),
                        next_followup_date: formatDateToYMD(data.next_followup_date),
                        interest: data.interestshown,
                        interestShown: mapInterestToColor(data.interestshown),
                    }));
                })
                .catch((error) =>
                    console.error("Error fetching selected institute data:", error),
                );
        }
    }, [selectedInstitute]);

    // Helper function to map interest to a color
    const mapInterestToColor = (interest) => {
        if (interest === "Not Interested") return "red";
        if (interest === "Follow Up") return "yellow";
        if (interest === "Interested") return "green";
        return "";
    };

    const formatDateToYMD = (dateValue) => {
        if (!dateValue) return "";

        const date = new Date(dateValue);
        if (Number.isNaN(date.getTime())) {
            return String(dateValue).slice(0, 10);
        }

        return date.toISOString().split("T")[0];
    };


    const filteredFollowups = Array.isArray(followupList)
        ? followupList.filter((item) =>
            item.schoolName
                ?.toLowerCase()
                .includes(searchSchool.toLowerCase())
        )
        : [];

    return (
        <div className="mainBlock">
            <h2>Customer Support Manager</h2>
            <CustomerSupportAside />


            <div className="cust-spt-conatiner">
                <div className="cust-spt-btn-container">
                    <button className="cust-spt-Btn"
                        onClick={() => setAddBtnPopup(true)}>ADD</button>
                </div>

                {/* If Manager want to add any follows */}
                {addBtnPopup && (
                    <>
                        <div
                            className="cust-spt-popup-overlay"
                            onClick={() => setAddBtnPopup(false)}
                        ></div>

                        <div className="cust-spt-follow-popup">
                            <div className="cust-spt-btn-container">

                                <button className="cust-spt-Btn"
                                    onClick={() => setAddBtnPopup(false)}>Close</button>
                            </div>

                            <h1>Add Follow-up</h1>

                            {/* Row 1: Employee Details */}
                            <div className="follow-up-form-row">
                                <div className="follow-up-form-group">
                                    <label>Employee ID:</label>
                                    <input
                                        type="text"
                                        name="empId"
                                        value={followUpData.empId}
                                        disabled
                                    />
                                </div>
                                <div className="follow-up-form-group">
                                    <label>Employee Name:</label>
                                    <input
                                        type="text"
                                        name="empName"
                                        value={followUpData.empName}
                                        disabled
                                    />
                                </div>
                                <div className="follow-up-form-group">
                                    <label>Designation:</label>
                                    <input
                                        type="text"
                                        name="designation"
                                        value={followUpData.designation}
                                        disabled
                                    />
                                </div>
                            </div>

                            {/* Row 2: Institute Name, Institute Address, Contact Person */}
                            <div className="follow-up-form-row">
                                <div className="follow-up-form-group"
                                    style={{ position: "relative" }}>
                                    <label>School Name:</label>
                                    <input

                                        type="text"
                                        value={schoolName}
                                        onChange={(e) => {
                                            const selected = schools.find(
                                                (school) =>
                                                    school.institute_name === e.target.value
                                            );

                                            setSchoolName(e.target.value);
                                            setSelectedInstitute(e.target.value);

                                            if (selected) {
                                                setFollowUpData((prev) => ({
                                                    ...prev,
                                                    instituteAddress:
                                                        selected.institute_address || "",
                                                    contactPerson:
                                                        selected.institute_authorized_person || "",
                                                    contactNumber:
                                                        selected.institute_contact_number || "",
                                                }));
                                            }
                                        }}
                                        list="schools-list"
                                        placeholder="Select School"
                                    />
                                    {schoolName && (
                                        <span
                                            onClick={() => {
                                                setSchoolName("");
                                                followUpData.instituteAddress = "";
                                                followUpData.contactPerson = "";
                                                followUpData.contactNumber = "";
                                                followUpData.lastVisited = ""
                                            }
                                            }
                                            style={{
                                                position: "absolute",
                                                right: "30px",
                                                top: "70%",
                                                transform: "translateY(-50%)",
                                                cursor: "pointer",
                                                fontSize: "18px",
                                                color: "#666"
                                            }}
                                        >
                                            ×
                                        </span>
                                    )}

                                    <datalist id="schools-list">
                                        {schools.map((school) => (
                                            <option key={school.id} value={school.institute_name} />
                                        ))}
                                    </datalist>
                                </div>
                                <div className="follow-up-form-group">
                                    <label>Institute Address:</label>
                                    <input
                                        type="text"
                                        name="instituteaddress"
                                        value={followUpData.instituteAddress}
                                    />
                                </div>
                                <div className="follow-up-form-group">
                                    <label>Contact Person:</label>

                                    <input
                                        type="text"
                                        name="contactPerson"
                                        value={followUpData.contactPerson}
                                    />
                                </div>
                            </div>

                            {/* Row 3: Contact Details */}
                            <div className="follow-up-form-row">
                                <div className="follow-up-form-group">
                                    <label>Contact Person Designation:</label>

                                    <input
                                        type="text"
                                        name="contactDesignation"
                                        value={followUpData.contactDesignation}
                                    />
                                </div>
                                <div className="follow-up-form-group">
                                    <label>Contact Number:</label>

                                    <input
                                        type="text"
                                        name="contactNumber"
                                        value={followUpData.contactNumber}
                                    />
                                </div>
                                <div className="follow-up-form-group">
                                    <label>Last Visited:</label>

                                    <input
                                        type="text"
                                        name="lastVisited"
                                        value={followUpData.lastVisited || "N/A"}
                                    />
                                </div>
                            </div>

                            {/* Row 4: Date and Exicutive name */}

                            {/* Row 5: Issuse Faced */}
                            <div className="follow-up-form-row">
                                <div className="follow-up-form-group">
                                    <label>Date</label>
                                    <input
                                        type="date"
                                        value={followupDate}
                                        max={new Date().toISOString().split("T")[0]}
                                        // onChange={(e) => setFollowupDate(e.target.value)}
                                        className="cust-spt-date"
                                    />
                                </div>
                                <div className="follow-up-form-group">
                                    <label>Issue faced</label>
                                    <textarea
                                        value={issueFaced}
                                        onChange={(e) => setIssueFaced(e.target.value)}
                                    />
                                </div>
                                <div className="follow-up-form-group">
                                    <label>Followup Person</label>
                                    <input type="text" value={Exicutive} readOnly />
                                </div>
                            </div>

                            <h3>Update Follow-up:</h3>
                            {/* Row 6: Update Follow-up - Comment & Interest Shown */}
                            <div className="follow-up-form-row">
                                <div className="follow-up-form-group">
                                    <label>Next Followup Date:</label>
                                    <input
                                        type="date"
                                        name="next_followup_date"
                                        value={followUpData.next_followup_date || ""}
                                        onChange={handleFollowUpChange}
                                        required
                                    />
                                </div>
                                <div className="follow-up-form-group">
                                    <label>Comment:</label>
                                    <textarea
                                        name="comment"
                                        value={followUpData.comment}
                                        onChange={handleFollowUpChange}
                                        required
                                    ></textarea>
                                </div>
                                <div className="follow-up-form-group">
                                    <label>Interest Shown:</label>
                                    <div className="follow-up-interest-circles">
                                        <div
                                            className={`follow-up-interest-circle red ${followUpData.interestShown === "red" ? "selected" : ""}`}
                                            onClick={() =>
                                                setFollowUpData({ ...followUpData, interestShown: "red" })
                                            }
                                        ></div>
                                        <div
                                            className={`follow-up-interest-circle yellow ${followUpData.interestShown === "yellow" ? "selected" : ""}`}
                                            onClick={() =>
                                                setFollowUpData({
                                                    ...followUpData,
                                                    interestShown: "yellow",
                                                })
                                            }
                                        ></div>
                                        <div
                                            className={`follow-up-interest-circle green ${followUpData.interestShown === "green" ? "selected" : ""}`}
                                            onClick={() =>
                                                setFollowUpData({
                                                    ...followUpData,
                                                    interestShown: "green",
                                                })
                                            }
                                        ></div>
                                    </div>
                                </div>
                                <div className="follow-up-form-group"></div>
                            </div>

                            <div className="cust-spt-followup">
                                {successMessage && (
                                    <p className="success-message">{successMessage}</p>
                                )}

                                {errorMessage && <p className="error-message">{errorMessage}</p>}
                                <div className="cust-spt-submitbtn">
                                    <button onClick={handleSubmit}>Submit</button>
                                </div>

                            </div>
                        </div>
                    </>)}
                {/* Table for manager to see the follows */}
                <div className="cust-spt-table cust-spt-man-table">
                    <h3>Customer Support Follow-ups</h3>

                    <div style={{ marginBottom: "15px" }}>
                        <input
                            type="text"
                            placeholder="Search School Name..."
                            value={searchSchool}
                            onChange={(e) => setSearchSchool(e.target.value)}
                            style={{
                                width: "300px",
                                padding: "10px",
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                            }}
                        />
                    </div>

                    <table>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>School Name</th>
                                <th>Issue Faced</th>
                                <th>Comment</th>
                                <th>Interest</th>
                                <th>Followup Person</th>
                            </tr>
                        </thead>

                        <tbody>
                            {Array.isArray(followupList) &&
                                filteredFollowups.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.followupDate}</td>

                                        <td
                                            // style={{
                                            //     color: "#007bff",
                                            //     cursor: "pointer",
                                            //     textDecoration: "underline",
                                            // }}
                                            // onClick={() => handleSchoolHistory(item.schoolName)}
                                        >
                                            {item.schoolName}
                                        </td>

                                        <td>{item.issueFaced}</td>
                                        <td>{item.comment}</td>
                                        <td>{item.interestShown}</td>
                                        <td>{item.followupPerson}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>

                    {schoolHistory.length > 0 && (
                        <div className="cust-spt-history">
                            <h3>History - {selectedHistorySchool}</h3>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Issue Faced</th>
                                        <th>Comment</th>
                                        <th>Interest</th>
                                        <th>Followup Person</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {schoolHistory.map((item) => (
                                        <tr key={item.id}>
                                            <td>{item.followupDate}</td>
                                            <td>{item.issueFaced}</td>
                                            <td>{item.comment}</td>
                                            <td>{item.interestShown}</td>
                                            <td>{item.followupPerson}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

            </div>

        </div>
    );
}

export default CustomerSupportManagerFollowup;
